import { PaymentsHistoryResponse } from "../../types/rtk/paymentsHistory/paymentsHistory";
import { apiSlice } from "../_api/api-slice";

const paymentsHistoryEndpoint = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPaymentHistory: build.query<PaymentsHistoryResponse, void>({
      query: () => ({
        url: `/user/payments`,
        method: "get",
      }),
    }),
    getPaymentInvoice: build.query<Blob, number>({
      query: (paymentId) => ({
        url: `/payment/${paymentId}/invoice`,
        method: "get",
        responseHandler: async (response: Response) => response.blob(),
        cache: 'no-cache',
      }),
    }),
  }),
  overrideExisting: false,
});



export const {
  useGetPaymentHistoryQuery,
  useLazyGetPaymentInvoiceQuery,
} = paymentsHistoryEndpoint;